import { render } from "./registrationPerson.vue?vue&type=template&id=ad62f732&scoped=true"
import script from "./registrationPerson.vue?vue&type=script&lang=js"
export * from "./registrationPerson.vue?vue&type=script&lang=js"

import "./registrationPerson.vue?vue&type=style&index=0&id=ad62f732&lang=scss&scoped=true"

import exportComponent from "/Users/ruslan/Desktop/birch/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ad62f732"]])

export default __exports__